enum SubscriptionStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  FREE= 'free',
}

export default SubscriptionStatus;
